export enum LoginStatus {
  Idle = 'Idle',
  InProgress = 'InProgress',
  Success = 'Success',
  MfaSuccess = 'MfaSuccess',
  NeedMfa = 'NeedMfa',
  FailedErrorCode = 'FailedErrorCode',
  Fail = 'Fail',
}
